const {
    getProductImpressionIdFromDOM,
    markAsProductImpressionElement
} = require('./helpers/impressions');

module.exports = {
    impressions: {
        getProductImpressionIdFromDOM,
        markAsProductImpressionElement
    }
};
